import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: "Commandes & Paiement",
      questions: [
        {
          q: "Comment passer une commande ?",
          a: "Pour passer commande, ajoutez simplement les produits souhaités à votre panier, puis cliquez sur 'Finaliser la commande'. Remplissez vos informations de livraison et validez. Vous recevrez une confirmation par email ou SMS."
        },
        {
          q: "Quels moyens de paiement acceptez-vous ?",
          a: "Nous acceptons uniquement le paiement à la livraison (cash on delivery). Vous payez en espèces au livreur lors de la réception de votre commande. Ce mode de paiement est 100% sécurisé."
        },
        {
          q: "Puis-je modifier ou annuler ma commande ?",
          a: "Oui, vous pouvez modifier ou annuler votre commande tant qu'elle n'a pas été expédiée. Contactez-nous rapidement via WhatsApp au +212 XXX-XXXXXX ou par email à contact@orima.ma."
        },
        {
          q: "Est-ce que je reçois une facture ?",
          a: "Oui, une facture est incluse dans votre colis lors de la livraison. Vous pouvez également demander une facture électronique en nous contactant."
        }
      ]
    },
    {
      category: "Livraison",
      questions: [
        {
          q: "Quels sont les délais de livraison ?",
          a: "Les délais de livraison sont de 1 à 2 jours ouvrables pour les grandes villes (Casablanca, Rabat, Marrakech, Fès, Tanger) et de 2 à 4 jours pour les autres localités au Maroc."
        },
        {
          q: "La livraison est-elle gratuite ?",
          a: "Oui, la livraison est entièrement gratuite partout au Maroc, sans minimum d'achat. C'est notre engagement pour vous offrir la meilleure expérience shopping."
        },
        {
          q: "Comment suivre ma commande ?",
          a: "Après l'expédition, vous recevrez un SMS ou email avec le numéro de suivi. Vous pouvez également nous contacter sur WhatsApp pour connaître le statut de votre commande en temps réel."
        },
        {
          q: "Livrez-vous dans toutes les villes du Maroc ?",
          a: "Oui, nous livrons dans toutes les villes et régions du Maroc, des grandes métropoles aux zones rurales."
        },
        {
          q: "Que faire si je suis absent lors de la livraison ?",
          a: "Si vous êtes absent, le livreur vous contactera pour convenir d'un autre moment de livraison. Assurez-vous que votre numéro de téléphone est correct."
        }
      ]
    },
    {
      category: "Retours & Échanges",
      questions: [
        {
          q: "Puis-je retourner un produit ?",
          a: "Oui, vous disposez de 7 jours à compter de la réception pour retourner un produit. Le produit doit être dans son emballage d'origine, non utilisé, avec toutes les étiquettes attachées."
        },
        {
          q: "Comment effectuer un retour ?",
          a: "Contactez notre service client via WhatsApp (+212 6 65 07 80 92) ou email (contact@orima.ma) pour initier un retour. Nous organiserons la récupération du produit gratuitement."
        },
        {
          q: "Quand serai-je remboursé ?",
          a: "Le remboursement est effectué dans un délai de 14 jours suivant la réception du produit retourné, après vérification de son état. Nous vous contacterons pour convenir du mode de remboursement."
        },
        {
          q: "Puis-je échanger un produit ?",
          a: "Oui, les échanges sont possibles selon la disponibilité du produit. Contactez-nous pour organiser un échange."
        }
      ]
    },
    {
      category: "Produits",
      questions: [
        {
          q: "Vos produits sont-ils authentiques ?",
          a: "Oui, tous nos produits sont authentiques et de qualité premium. Nous sélectionnons rigoureusement nos fournisseurs et garantissons l'authenticité de chaque article."
        },
        {
          q: "Comment choisir la bonne taille ?",
          a: "Consultez notre guide des tailles disponible sur chaque page produit. Pour les sacs et portefeuilles, les dimensions sont indiquées. En cas de doute, contactez-nous."
        },
        {
          q: "Les couleurs sont-elles fidèles aux photos ?",
          a: "Nous faisons de notre mieux pour représenter fidèlement les couleurs. Cependant, elles peuvent légèrement varier selon votre écran. N'hésitez pas à nous demander des photos supplémentaires."
        },
        {
          q: "Proposez-vous des garanties sur vos produits ?",
          a: "Oui, tous nos produits bénéficient de la garantie légale de conformité. En cas de défaut de fabrication, contactez-nous immédiatement."
        }
      ]
    },
    {
      category: "Compte Client",
      questions: [
        {
          q: "Dois-je créer un compte pour commander ?",
          a: "Non, vous pouvez commander en tant qu'invité. Cependant, créer un compte vous permet de suivre vos commandes, sauvegarder vos adresses et accéder à des offres exclusives."
        },
        {
          q: "Comment créer un compte ?",
          a: "Cliquez sur 'Mon Compte' en haut de la page, puis sur 'Créer un compte'. Remplissez le formulaire avec vos informations et validez."
        },
        {
          q: "J'ai oublié mon mot de passe, que faire ?",
          a: "Cliquez sur 'Mot de passe oublié' sur la page de connexion. Entrez votre email et vous recevrez un lien pour réinitialiser votre mot de passe."
        }
      ]
    },
    {
      category: "Contact & Support",
      questions: [
        {
          q: "Comment vous contacter ?",
          a: "Vous pouvez nous contacter via WhatsApp au +212 6 65 07 80 92, par email à contact@orima.ma, ou via nos réseaux sociaux (Instagram, TikTok, Facebook)."
        },
        {
          q: "Quels sont vos horaires de service client ?",
          a: "Notre service client est disponible 7j/7 de 9h à 21h. Nous répondons généralement en quelques minutes sur WhatsApp."
        },
        {
          q: "Puis-je visiter votre boutique physique ?",
          a: "ORIMA est une boutique en ligne exclusive. Nous n'avons pas de point de vente physique pour vous offrir les meilleurs prix."
        },
        {
          q: "Proposez-vous un programme de fidélité ?",
          a: "Oui ! Suivez-nous sur Instagram et TikTok pour bénéficier d'offres exclusives, codes promo et avant-premières de nos nouvelles collections."
        }
      ]
    }
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-6 transition-colors"
          >
            <FiArrowLeft />
            Retour à l'accueil
          </Link>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
            Questions Fréquentes
          </h1>
          <p className="text-gray-300 mt-4 text-lg">
            Trouvez rapidement les réponses à vos questions
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        
        {/* Intro */}
        <div className="mb-12 text-center">
          <p className="text-gray-600 text-lg">
            Vous avez une question ? Consultez notre FAQ ci-dessous. Si vous ne trouvez pas 
            la réponse, n'hésitez pas à nous contacter directement.
          </p>
        </div>

        {/* FAQ Sections */}
        {faqs.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-900">
              {category.category}
            </h2>
            <div className="space-y-4">
              {category.questions.map((item, questionIndex) => {
                const index = `${categoryIndex}-${questionIndex}`;
                const isOpen = openIndex === index;
                
                return (
                  <div
                    key={questionIndex}
                    className="border border-gray-200 rounded-lg overflow-hidden hover:border-gray-900 transition-colors"
                  >
                    <button
                      onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                      className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-semibold text-gray-900 pr-8">
                        {item.q}
                      </span>
                      {isOpen ? (
                        <FiChevronUp className="flex-shrink-0 w-5 h-5 text-gray-900" />
                      ) : (
                        <FiChevronDown className="flex-shrink-0 w-5 h-5 text-gray-600" />
                      )}
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 bg-gray-50">
                        <p className="text-gray-700 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Contact CTA */}
        <div className="mt-16 bg-gray-900 text-white p-8 rounded-2xl text-center">
          <h2 className="text-2xl font-bold mb-4">Vous n'avez pas trouvé votre réponse ?</h2>
          <p className="text-gray-300 mb-6">
            Notre équipe est là pour vous aider. Contactez-nous et nous vous répondrons rapidement.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://wa.me/212665078092"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-600 transition-all inline-flex items-center gap-2"
            >
              <span>WhatsApp</span>
            </a>
            <a
              href="mailto:contact@orima.ma"
              className="bg-white text-gray-900 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all"
            >
              Email
            </a>
          </div>
        </div>

        {/* Back button */}
        <div className="text-center mt-12 pt-8 border-t border-gray-200">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 font-semibold"
          >
            <FiArrowLeft />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
